import { useMemo } from "react";

import {
  EditFRDMeasurementConfigTask,
  FRDMeasurementConfigTask,
} from "@nens/brostar/uploadapi-client";

import { getApi } from "@/api/api-configuration";
import { getFormObjectValues, initializeFormEditingState } from "@/helpers/helpers";
import { useAfterFormSubmit } from "@/hooks/use-after-form-submit";
import { BrostarForm, useBrostarFormDataStorage } from "@/libs/brostar-form";
import { FrdMeasurementConfigFormProps } from "@/types/form-types";

import { useFrdUiSchema } from "../../schema/frd-ui-schema";

import { getFrdMeasurementConfigSchema } from "./schema/frd-measurement-config-schema";

export function FrdMeasurementConfigForm(props: FrdMeasurementConfigFormProps) {
  const api = getApi();
  const afterSubmit = useAfterFormSubmit();
  const { type, oldUploadTask, task } = getFormObjectValues(props);

  const { isEditing, getIsEditing } = initializeFormEditingState(props);

  const { formData, handleChange } = useBrostarFormDataStorage<
    FRDMeasurementConfigTask | EditFRDMeasurementConfigTask
  >({ key: "frdMeasurementConfig", task });

  const uiSchema = useFrdUiSchema(formData?.metadata.qualityRegime);
  const schema = useMemo(
    () => getFrdMeasurementConfigSchema({ type, isEditing }),
    [type, isEditing]
  );

  const onSubmit = async () => {
    if (!formData) return;
    if (getIsEditing(formData)) {
      await api.editFrdMeasurementConfig(formData);
    } else {
      await api.createFrdMeasurementConfig(formData);
    }
    if (oldUploadTask?.uuid) api.apiUploadtasksDelete({ uuid: oldUploadTask.uuid });
    await afterSubmit();
  };

  return (
    <BrostarForm
      schema={schema}
      uiSchema={uiSchema}
      formData={formData}
      onChange={handleChange}
      onSubmit={onSubmit}
      uploadTask={oldUploadTask}
    />
  );
}
